<script>
    import { createEventDispatcher } from "svelte";
    import { format } from "svelte-i18n";

    let { assetTags = [], allTags = $bindable([]) } = $props();


    let formData = $state({tag: 'cancel'});

    let assetTagsIds = [];
    for (let tag of assetTags) {
        assetTagsIds = [...assetTagsIds, tag.id];
    }
    allTags = allTags.filter((tag) => !assetTagsIds.includes(tag.id));

    const dispatch = createEventDispatcher();
</script>

<div class="mb-3">
    <label for="tagsSelect">Asociar etiqueta existente</label>
    <select
        id="tagsSelect"
        name="tagsSelect"
        class="form-control"
        style="height: 28px; clear: left; max-width: 180px;font-size: 12px; margin-right: 10px;"
        bind:value={formData.tag}
    >
        <option value="cancel">{$format("buttons.select_tag.select")}</option>
        <option disabled>----------</option>
        {#each allTags as tag}
            <option value={tag.id}>{tag.name}</option>
        {/each}
    </select>
</div>
<button class="btn btn-default btn-primary mt-3" style="clear:both;" onclick={()=> dispatch("submit", formData)}>{$format("buttons.save")}</button>
<button class="btn btn-default mt-3" style="clear:both;" onclick={()=> dispatch("cancel")}>{$format("buttons.cancel")}</button>
